import styled from 'styled-components';

import { CheckBox } from 'components/primitives/check-box';
import { AttentionCard } from 'components/uikit/AttentionCard/AttentionCard';
import { Checkbox } from 'components/uikit/Form/Checkbox/Checkbox';

import { FormGridRowBase, FormHeader } from '../AnketaForm.styles';

export const Mgrid = styled(FormGridRowBase)`
  grid-template-areas: '. h h h h h h .';
`;

export const Docgrid = styled(FormGridRowBase)`
  grid-template-areas: ${(p) => p.template};
`;

export const Title = styled(FormHeader)``;

export const SelfAgreeCheckbox = styled(Checkbox).attrs({ size: 'xs' })`
  grid-area: ch1;
  justify-content: flex-end;
  margin-top: 32px;
  margin-bottom: 24px;
`;

export const Multidrive = styled(CheckBox)`
  margin-left: calc(100% / 8);
  width: 106px;
`;

export const Anchor = styled.div``;

export const DocsHelp = styled.span`
  grid-area: go;
  text-align: start;
  margin-bottom: 10px;

  font: var(--font-regular-15);

  p {
    margin: 0;
  }

  ul {
    margin-bottom: 20px;
    padding-left: 40px;
  }
`;

export const FilesDescription = styled(DocsHelp)`
  grid-area: desc;
  margin-top: 14px;
  color: var(--color-grey-11_60);

  font: var(--font-regular-13);
`;

export const AttentionCardWrapper = styled(FormGridRowBase)`
  grid-template-areas: '. ac ac ac ac ac ac .';
`;

export const StyledAttentionCard = styled(AttentionCard)`
  grid-area: ac;
  margin-top: 40px;
`;
